export default __webpack_public_path__ + "static/media/dinesh_bhanushali.7a929a70.jpeg";